export default {
	"foreaccountroad": {
		"settlementStatus": "e结算状态"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/foreaccount/foreaccount.js